export default "__VITE_ASSET__8a1123ba__"